module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
/** Site page site under constraction */
(function(fox) {

	fox.registerWidget('SitePage_SiteUnderConstruction', {

		configure: function () {
			this.registerOptions('', {
				widgets: {
					newsletter: {
						template: 'stateoff_newsletterBlock',
						handleWom: {
							subscribeNotValidForm: {
								event: 'formNotValid',
								widget: '#form #validator',
								callback: '@parent:formNotValid'
							}
						},
						handleDom: {
							focus: {
								target: 'input',
								event: 'focus',
								callback: '@parent:inputHasFocus'
							}
						}
					},
					socialAppsBlock: {
						widget: 'Stateoff_SocialApps_Block'
					},
					tipmeBlock: {
						widget: 'Widget',
						manualRender: true,
						template: 'stateoff_content_tipmeblock',
						container: '#tipme',
						widgets: {
							tipme: {
								widget: 'Content_Tipme',
								'embed.container': '#tipme-container',
								template: 'stateoff_content_tipme',
								widgets: {
									'tipsDl.hooks.onLoaded': function() {
										var tipOption = this.getCollection().filter(function (v) {
											return Number(v.type) === 1;
										}).pop();
										
										if (tipOption) {
											var tipmeBlock = fox.wom.selectFirst('~#tipmeBlock');
											tipmeBlock.render();
											tipmeBlock.setOption('manualRender', false);
											this.dispatchEvent('loaded');
										}
									},
									'confirmPopup.widgets.tipsPopupContainer.widgets.content': {
										handleDom: {
											handleFocusInput: {
												event: 'focus',
												target: 'input[type="text"]',
												callback: function (el) {
													var el = $(el);
													el.removeClass('error').parent().removeClass('error');
												}
											}
										}
									}
								},
								'hooks.onHandleErrorToggle': function (data) {
									var state = data.state;
									fox.dom[state ? 'removeClass' : 'addClass']('error', data.el.parentNode)
								}
							}
						}
					}
				}
			});
		
			this.callParent('configure', arguments);
		},

		inputHasFocus: function(el) {
			var $el = $(el);
				
			if ($el.length) {
				$el.parent().removeClass('error').next().text('').removeClass('show');
			}
		},

		formNotValid: function(data) {
			fox.each(data.errorStack, function (v, field) {
				var $el = $(this.dom1('[name="' + field + '"]'));

				if ($el.length) {
					$el.parent().next().text(v[0].message);
				}
			}, this);
		}

	}, 'Site_Page');
	
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/sitepage/siteUnderConstruction.js
// module id = 915
// module chunks = 4